<template>
  <b-modal
    id="modal-criar-pessoa"
    ref="modalCriarPessoa"
    title="Criar Pessoa Responsável"
    size="md"
    @ok="handleOk"
    @hidden="resetModal"
  >
    <validation-observer ref="validationObserver">
      <b-form>
        <!-- Nome (OBRIGATÓRIO) -->
        <b-form-group label="Nome *">
          <validation-provider
            #default="{ errors }"
            rules="required"
            name="Nome"
          >
            <b-form-input
              v-model="form.nome"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Email (OBRIGATÓRIO) -->
        <b-form-group label="E-mail *">
          <validation-provider
            #default="{ errors }"
            rules="required|email"
            name="E-mail"
          >
            <b-form-input
              v-model="form.email"
              type="email"
              :state="errors.length > 0 ? false : null"
              @blur="validarEmail"
            />
            <small class="text-danger">{{ errors[0] || erroEmail }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Celular (OPCIONAL) -->
        <b-form-group label="Celular">
          <b-form-input
            v-model="form.celular"
            v-mask="'(##) #####-####'"
          />
        </b-form-group>

        <!-- Como chegou à Contabilidade (OBRIGATÓRIO) -->
        <b-form-group label="Como chegou à Contabilidade? *">
          <b-form-radio
            v-for="opcao in opcoesComoChegou"
            :key="opcao.value"
            v-model="form.comoChegou"
            :value="opcao.value"
            class="mb-2"
          >
            {{ opcao.text }}
          </b-form-radio>
          <small
            v-if="erroComoChegou"
            class="text-danger"
          >{{ erroComoChegou }}</small>
        </b-form-group>

        <!-- Campo condicional: "Quem fez a indicação?" -->
        <b-form-group
          v-if="form.comoChegou === 'Indicacao'"
          label="Quem fez a indicação?"
        >
          <b-form-input v-model="form.usuarioIndicacao" />
        </b-form-group>

        <!-- Campo condicional: "Complemente (Opcional)" -->
        <b-form-group
          v-if="form.comoChegou === 'Outros'"
          label="Complemente (Opcional)"
        >
          <b-form-input v-model="form.complementoOutros" />
        </b-form-group>
      </b-form>
    </validation-observer>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancelar
      </b-button>
      <b-button
        variant="primary"
        @click="ok()"
      >
        Criar Pessoa
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BModal, BForm, BFormGroup, BFormInput, BFormRadio, BButton,
} from 'bootstrap-vue'
import api from '@/app-modulo/comercial/pessoa/shared/services/api'

export default {
  name: 'ModalCriarPessoa',

  components: {
    ValidationObserver,
    ValidationProvider,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BButton,
  },

  props: {
    empresaId: {
      type: Number,
      default: null,
    },
    dadosIniciais: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      form: {
        nome: '',
        email: '',
        celular: '',
        comoChegou: null,
        usuarioIndicacao: '',
        complementoOutros: '',
        empresas: [],
        ativo: true,
      },
      erroEmail: '',
      erroComoChegou: '',
      opcoesComoChegou: [
        { text: 'Indicação', value: 'Indicacao' },
        { text: 'Facebook', value: 'Facebook' },
        { text: 'Instagram', value: 'Instagram' },
        { text: 'Google', value: 'Google' },
        { text: 'Outros', value: 'Outros' },
      ],
    }
  },

  methods: {
    show() {
      // Vincula automaticamente à empresa, deixando os campos da pessoa em branco/editáveis
      if (this.empresaId) {
        this.form.empresas = [{ id: this.empresaId }]
      }

      this.$refs.modalCriarPessoa.show()
    },

    async validarEmail() {
      if (this.form.email) {
        try {
          const response = await api.validaEmail(0, this.form.email)
          if (response.data) {
            this.erroEmail = 'E-mail já cadastrado'
          } else {
            this.erroEmail = ''
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Erro ao validar email:', error)
        }
      }
    },

    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()

      // Validações
      const isValid = await this.$refs.validationObserver.validate()

      if (!this.form.comoChegou) {
        this.erroComoChegou = 'Selecione uma opção'
        return
      }

      if (!isValid || this.erroEmail) {
        return
      }

      try {
        // Cria pessoa
        const response = await api.createPessoa(this.form)

        this.$sucesso('Pessoa criada com sucesso!')

        // Emite evento com os dados da pessoa criada
        this.$emit('pessoa-criada', response.data)

        this.$refs.modalCriarPessoa.hide()
      } catch (error) {
        this.$erro(`Erro ao criar pessoa: ${error.message}`)
      }
    },

    resetModal() {
      this.form = {
        nome: '',
        email: '',
        celular: '',
        comoChegou: null,
        usuarioIndicacao: '',
        complementoOutros: '',
        empresas: [],
        ativo: true,
      }
      this.erroEmail = ''
      this.erroComoChegou = ''
      if (this.$refs.validationObserver) {
        this.$refs.validationObserver.reset()
      }
    },
  },
}
</script>
